require("core-js/modules/es6.regexp.replace");
// 老司机环境下，修改webpack publicPath
if (window.previewPid) {
  var a = document.createElement('A');
  // eslint-disable-next-line
  a.href = __webpack_require__.p;
  var path = a.href;
  path = path.replace(/^https/, 'http');
  // eslint-disable-next-line
  __webpack_require__.p = '//node.video.qq.com/x/vip/quick_cgi/preview/28/script?pid=' + window.previewPid + '&src=' + encodeURIComponent(path);
}